const MISC_ROUTES = {
  ANALYTICS: 'https://us.i.posthog.com',
  LANDING: 'https://arimadata.com',
};

const LANDING_ROUTES = {
  HOME: `${MISC_ROUTES.LANDING}/`,
  PRIVACY: `${MISC_ROUTES.LANDING}/privacy`,
  TERMS: `${MISC_ROUTES.LANDING}/terms`,
  ABOUT: `${MISC_ROUTES.LANDING}/company/about`,
  CONTACT: `${MISC_ROUTES.LANDING}/company/contact`,
  ARIMA101: `${MISC_ROUTES.LANDING}/company/arima101`,
  BLOGS: `${MISC_ROUTES.LANDING}/company/blogs`,
  CASES: `${MISC_ROUTES.LANDING}/company/cases`,
  PRODUCTS_PERSONA: `${MISC_ROUTES.LANDING}/products/persona`,
  PRODUCTS_CROSSMEDIA: `${MISC_ROUTES.LANDING}/products/crossmedia`,
  PRODUCTS_LOCATION: `${MISC_ROUTES.LANDING}/products/location-intelligence`,
  PRODUCTS_MMM: `${MISC_ROUTES.LANDING}/products/marketing-mix-model`,
  PRODUCTS_SYNTHETIC: `${MISC_ROUTES.LANDING}/products/synthetic-society`,
  SOLUTIONS_ADVERTISERS: `${MISC_ROUTES.LANDING}/solutions/advertisers`,
  SOLUTIONS_AGENCIES: `${MISC_ROUTES.LANDING}/solutions/media-agencies`,
  SOLUTIONS_MEDIAOWNERS: `${MISC_ROUTES.LANDING}/solutions/media-owners`,
  SOLUTIONS_DATASCIENTISTS: `${MISC_ROUTES.LANDING}/solutions/data-scientists`,
};

const DASHBOARD_ROUTES = {
  HOME: '/dashboard',
  AUDIENCE_BUILDER: '/dashboard/discovery',

  // CORE MODULES
  MODULES: '/dashboard/module',
  MODULES_HOME: '/dashboard/modules', // not used directly
  LI_MODULE: '/dashboard/modules/limodule',
  CROSS_MEDIA_MODULE: '/dashboard/modules/cross-media',
  MMM: '/dashboard/marketingmix',

  // PERSONA MODULES
  PERSONA_MODULES: '/dashboard/modules/landing',
  BEHAVIOUR_MODULE: '/dashboard/modules/behaviour',
  AUDIENCE_OVERVIEW_MODULE: '/dashboard/modules/audienceoverview',
  CROSS_TAB_MODULE: '/dashboard/modules/audiencecrosstab',
  MEDIA_USAGE_MODULE: '/dashboard/modules/mediausage',

  // MISC
  AUDIENCES: '/dashboard/audiences',
  REPORTS: '/dashboard/reports',
  THEMES: '/dashboard/manage-themes',

  // USER PAGE
  USER_PAGE: '/dashboard/userpage',
  ADMIN: '/dashboard/admin',
  USER_TRACKING: '/dashboard/usertracking',
  EVENT_TRACKING: '/dashboard/eventtracking',
  CMS: '/dashboard/cms',
  MEDIUM_POSTS: '/dashboard/mediumposts',
};

const AUTH_ROUTES = {
  HOME: '/account', // not used directly
  LOGIN: '/account/login',
  SIGN_UP: '/account/signup',
  FORGOT_PASSWORD: '/account/forgot-password',
  AUTH_ACTION: '/account/__/auth/action',
};

export { LANDING_ROUTES, DASHBOARD_ROUTES, AUTH_ROUTES, MISC_ROUTES };
